module.exports = __webpack_public_path__ + "static/assets/e3338448c7b3e3a019ac707a3bcd5762.png";